import React from 'react';
import { Link, Outlet, useLocation, useNavigate } from 'react-router-dom';
import myLogo from '../../LOGO.png';


const Layout = () => {
  const location = useLocation(); // Get the current location
  const currentPath = location.pathname; // Get the current path

  const navigate = useNavigate();

  const handleGoToDashboard = () => {
    navigate('/dashboard');
  };

  const handleLogout = (e) => {
    e.preventDefault();
    // Create a hidden form to perform a POST logout
    const form = document.createElement('form');
    form.method = 'POST';
    form.action = `${process.env.REACT_APP_NOTIFICATION_SERVICE_APIGW_ENDPOINT}/logout`;
    document.body.appendChild(form);
    form.submit();
  };

  return (
    <div className="layout">

      <div className="main-content">
        <nav className="side-pane">
          <ul>
            <li><Link to=""
              className={currentPath === '/email' ? 'active' : ''}>Email Notification Sent</Link></li>
            <li><Link to="email-template"
              className={currentPath === '/email/email-template' ? 'active' : ''}>Template Maintenance</Link></li>
            <li><Link to="email-category"
              className={currentPath === '/email/email-category' ? 'active' : ''}>Email Category</Link></li>
            <li><Link to="email-template-variable"
              className={currentPath === '/email/email-template-variable' ? 'active' : ''}>Email Template Variable</Link></li>
            <li><Link to="email-system-variable"
              className={currentPath === '/email/email-system-variable' ? 'active' : ''}>System Variable</Link></li>
            <li><Link to="email-add-corp-sender-cred"
              className={currentPath === '/email/email-add-corp-sender-cred' ? 'active' : ''}>Create/Add new corporate Email Sender's Credentials</Link></li>
            <li><Link to="email-send-manual-trigger"
              className={currentPath === '/email/email-send-manual-trigger' ? 'active' : ''}>Email Send Trigger Manually</Link></li>
            <li className="logout-item">
              <button
                type="button"
                onClick={handleLogout}
                className="logout-button"
                style={{ marginTop: '20px', cursor: 'pointer' }}
              >
                Logout
              </button>
            </li>
            <li className="back-to-dashboard-item">
              <button
                type="button"
                onClick={handleGoToDashboard}
                className="back-to-dashboard-button"
                style={{ marginTop: '20px', cursor: 'pointer' }}
              >
                Dashboard
              </button>
            </li>
            {/* Add more links as needed */}
          </ul>
        </nav>
        <div className="content-pane">
          <Outlet /> {/* This is crucial for rendering child route components */}
          <footer className="company-footer">
            <img src={myLogo} alt="Logo" className="footer-logo" />

            <div className="footer-info">
              <p className="copyright-text">
                &copy; {new Date().getFullYear()} PRIMEDHA Technologies Pvt Ltd. All rights reserved.
              </p>
            </div>
          </footer>
        </div>
      </div>
    </div>
  );
};

export default Layout;
